import React, { CSSProperties, Fragment, useEffect, useRef } from 'react'
import { observer, useLocalObservable } from 'mobx-react-lite'
import dayjs from 'dayjs'
import moment from 'moment'
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Collapse,
  Empty,
  List,
  Modal,
  Row,
  Space,
  Tag,
  Alert
} from 'antd'
import { DatePicker } from 'antd/es'
import {
  CaretDownOutlined,
  CaretUpOutlined,
  PlusOutlined,
  ReloadOutlined,
  UserSwitchOutlined
} from '@ant-design/icons'
// import VirtualList from 'rc-virtual-list'
import { contexts } from '@/domains'
import useFormatData from '@/domains/hooks/useFormatData'
import { DeliveryItem } from '@/domains/hooks/useDelivery'
import DeliveryFormModal, {
  ImperativeHandle
} from './components/DeliveryFormModal'
import DeliveryCardItem from './components/DeliveryCardItem'
import ParticipantItem from './components/ParticipantItem'
import ParticipantTags from './components/ParticipantTags'
import DeliveryTag from '@/delivery/components/DeliveryTag'
import SiteBreadcrumb from '@/components/SiteBreadcrumb'
import { globalStore, load } from '@/common'
import { IconFont } from '@/common/index';
import { getStatusStyle, getStatusTagTextStyle } from '@/utils/S' 

type Store = {
  mode: 'create' | 'update' | 'delete'
  visualMode: 'project' | 'participant'
  deliverySortType: 'desc' | 'asc'
  dialogMode:boolean
}

const { GlobalContext, DeliveryContext, WorkspaceContext } = contexts

const TaskSizeDesc = {
  0: 'S',
  1: 'M',
  2: 'L',
  3: 'XL'
}

const TaskSizeColor = {
  0: '#D7F4D2',
  1: '#DAF0FC',
  2: '#F9E9CD',
  3: '#F8DFDE'
}
let timer
function DeliveryList(): JSX.Element {
  const { onlyFridayAvailable } = useFormatData()
  const { enableLoad } = GlobalContext.useContainer()
  const {
    currentDate,
    sortBy,
    sortType,
    deliveryList,
    projectList,
    userRecord,
    participantRecord,
    init,
    handleRefresh,
    handleDateChange,
    sortDeliveryList,
    handleDeleteDeliveryItem
  } = DeliveryContext.useContainer()
  const {
    init: initWorkspace,
  } = WorkspaceContext.useContainer()
  const store = useLocalObservable<Store>(() => ({
    mode: null,
    visualMode: 'project',
    deliverySortType: 'desc',
    dialogMode:false
  }))

  const ref = useRef<ImperativeHandle>() 

  useEffect(() => { 
    if(!globalStore.currentUser){
      load();
    }
  }, []) 


  const handleAction = (
    type: 'create' | 'update' | 'delete',
    record?: DeliveryItem
  ): void => {
    store.mode = type 
    switch (type) {
      case 'create':
      case 'update':
        store.mode = record ? 'update' : 'create'
        store.dialogMode =true
        ref.current.open(record)
        break
      case 'delete':
        Modal.confirm({
          title: '删除交付项',
          content: '是否确认删除该交付项',
          onOk: () => {
            handleDeleteDeliveryItem(record.id)
          }
        })
        break
      default:
        break
    }
  }

  const handleSort = (
    type:
      | 'businessLineId'
      | 'morningMeetingId'
      | 'taskTypeId'
      | 'taskStatusId'
      | 'participant'
  ): void => {
    let sort

    if (sortType === 'desc') {
      sort = 'asc'
    } else {
      sort = 'desc'
    }

    sortDeliveryList(type, sort)
  }

  const handleDeliverySort = (a, b): number => {
    if (store.deliverySortType === 'desc') {
      return b[1].length - a[1].length > 0 ? 1 : -1
    } else {
      return b[1].length - a[1].length > 0 ? -1 : 1
    }
  }

  // const handleScroll = (e: React.UIEvent<HTMLElement, UIEvent>) => {
  //   console.log(e.currentTarget.scrollHeight)
  // }

  const renderTaskSizeTip = (): JSX.Element => {
    return (
      <Alert
        style={{ width: '100%', fontWeight: '500',border:'none'}}
        message={
          <div className="flex items-center">
            <span style={{fontWeight:200}}>任务规模换算公式：</span>
            <Tag
              style={{
                marginLeft: 10,
                color: '#000',
                fontWeight: '500'
              }}
              color={TaskSizeColor[0]}
            >
              S
            </Tag>
            <span style={{fontWeight:200}}>1~1.5人/周</span>
            <Tag
              style={{
                marginLeft: 10,
                color: '#000',
                fontWeight: '500'
              }}
              color={TaskSizeColor[1]}
            >
              M
            </Tag>
            <span style={{fontWeight:200}}>2~3人/周</span>
            <Tag
              style={{
                marginLeft: 10,
                color: '#000',
                fontWeight: '500'
              }}
              color={TaskSizeColor[2]}
            >
              L
            </Tag>
            <span style={{fontWeight:200}}>4~6人/周</span>
            <Tag
              style={{
                marginLeft: 10,
                color: '#000',
                fontWeight: '500'
              }}
              color={TaskSizeColor[3]}
            >
              XL
            </Tag>
            <span style={{fontWeight:200}}>6~9人/周</span>
          </div>
        }
        type="warning"
      />
    )
  }

  useEffect(() => {
    if (!enableLoad) return
    initWorkspace()
    init()

    timer = setInterval(() => { 
      if (!document.hidden && !store.dialogMode) {
        handleRefresh()
        console.log("交付项数据同步成功！")
      }
    }, 5 * 1000)
    return () => {
      clearInterval(timer)
    }
  }, [enableLoad])
 

  return (
    <div className="w-full flex flex-col week-delivery">
      <SiteBreadcrumb name="周交付管理" />
      <Card>
        <Space className="w-full" size={15} direction="vertical">
          <Row justify="space-between">
            <Col>
              <Space size={10} className='date-pick'>
                <IconFont type='icon-riqifanwei1' style={{fontSize:20, marginRight:15, paddingLeft:10, lineHeight:'16px'}} />
                <DatePicker
                  value={currentDate ? dayjs(currentDate) : undefined}
                  format="YYYY-MM-DD ddd"
                  disabledDate={onlyFridayAvailable}
                  inputReadOnly
                  onChange={(date) => {
                    if (date != null && date.day() !== 5) {
                      return
                    }
                    handleDateChange(
                      date ? moment(date.format('YYYY-MM-DD')) : undefined,
                    )
                  }}
                  className='date-picker' 
                />
                <Button
                  type='text'
                    onClick={() => {
                      handleDateChange(
                        moment(currentDate).subtract(1, 'weeks').isoWeekday(5)
                      )
                    }}
                  >
                  上周
                </Button>
                <Button
                type='text'
                  onClick={() => {
                    handleDateChange(
                      moment(currentDate).add(1, 'weeks').isoWeekday(5)
                    )
                  }}
                >
                  下周
                </Button>
                <Button
                type='text'
                  onClick={() => {
                    handleDateChange(undefined)
                  }}
                >
                  未排期
                </Button>
              </Space>
            </Col>
            <Col>
              <Space size={10}>
                <Button
                  icon={<UserSwitchOutlined />}
                  onClick={() => {
                    store.visualMode =
                      store.visualMode === 'project' ? 'participant' : 'project'
                  }}
                >
                  {store.visualMode === 'project' ? '人员视角' : '交付视角'}
                </Button>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => handleAction('create')}
                >
                  添加交付
                </Button>
              </Space>
            </Col>
          </Row>
          {store.visualMode === 'project' ? (
            <>
              <Row justify="space-between">
                <Col>
                  <Space size={10} className='sort-options'>
                    <IconFont type='icon-icon-' style={{fontSize:20, marginRight:15, paddingLeft:10, marginTop:'3px'}}/>
                    <Button 
                      type='text'
                      onClick={() => handleSort('businessLineId')}
                    >
                      业务线
                      {sortBy === 'businessLineId' && sortType === 'asc' && (
                        <CaretUpOutlined />
                      )}
                      {sortBy === 'businessLineId' && sortType === 'desc' && (
                        <CaretDownOutlined />
                      )}
                    </Button>
                    <Button 
                      type='text'
                      onClick={() => handleSort('morningMeetingId')}
                    >
                      晨会
                      {sortBy === 'morningMeetingId' && sortType === 'asc' && (
                        <CaretUpOutlined />
                      )}
                      {sortBy === 'morningMeetingId' && sortType === 'desc' && (
                        <CaretDownOutlined />
                      )}
                    </Button>
                    <Button 
                     type='text'
                      onClick={() => handleSort('taskTypeId')}
                    >
                      类型
                      {sortBy === 'taskTypeId' && sortType === 'asc' && (
                        <CaretUpOutlined />
                      )}
                      {sortBy === 'taskTypeId' && sortType === 'desc' && (
                        <CaretDownOutlined />
                      )}
                    </Button>
                    <Button 
                     type='text'
                      onClick={() => handleSort('taskStatusId')}
                    >
                      状态
                      {sortBy === 'taskStatusId' && sortType === 'asc' && (
                        <CaretUpOutlined />
                      )}
                      {sortBy === 'taskStatusId' && sortType === 'desc' && (
                        <CaretDownOutlined />
                      )}
                    </Button>
                    <Button 
                     type='text'
                      onClick={() => handleSort('participant')}
                    >
                      参与人数
                      {sortBy === 'participant' && sortType === 'asc' && (
                        <CaretUpOutlined />
                      )}
                      {sortBy === 'participant' && sortType === 'desc' && (
                        <CaretDownOutlined />
                      )}
                    </Button>
                  </Space>
                </Col>
                <Col>
                  共{deliveryList.length || 0}条
                  <Button
                    style={{ marginLeft: 15 }} 
                    className='btn-refresh'
                    icon={<ReloadOutlined />}
                    onClick={handleRefresh}
                  >
                    刷新
                  </Button>
                </Col>
              </Row>
              <Row>{renderTaskSizeTip()}</Row>
              <Row>
                {deliveryList.length > 0 ? (
                  // 交付项列表
                  <List className="w-full">
                    <Collapse>
                      {deliveryList.map((item) => (
                        <Collapse.Panel
                          key={item.id}
                          showArrow={false}
                          header={
                            <Row justify="space-between" align="middle" className="w-full delivery-item-header">
                              <Col flex="auto" className="flex items-center min-w-0">
                                {item.taskSize !== undefined && (
                                  <Tag
                                    style={{
                                      fontSize: 14,
                                      padding: '2px 15px',
                                      fontWeight: '500',
                                      color: '#000'
                                    }}
                                    color={TaskSizeColor[item.taskSize]}
                                  >
                                    {TaskSizeDesc[item.taskSize]}
                                  </Tag>
                                )}
                                <DeliveryTag>
                                  {globalStore.meetingRecord[item.morningMeetingId] &&
                                    globalStore.meetingRecord[item.morningMeetingId].name}
                                </DeliveryTag>

                                <span className="week-task-name">{item.taskName}</span>

                                <Tag
                                  style={{
                                    fontSize: 14,
                                    padding: '2px 15px',
                                    ...getStatusTagTextStyle(
                                      globalStore.taskStatusRecord[item.taskStatusId]?.name
                                    )
                                  }}
                                  color={
                                    globalStore.taskStatusRecord[item.taskStatusId] &&
                                    getStatusStyle(globalStore.taskStatusRecord[item.taskStatusId].name)
                                  }
                                >
                                  {globalStore.taskStatusRecord[item.taskStatusId] &&
                                    globalStore.taskStatusRecord[item.taskStatusId].name}
                                </Tag>
                              </Col>
                              <Col flex="none">
                                <ParticipantTags userList={item.userList} />
                              </Col>
                            </Row>
                          }
                        >
                          <DeliveryCardItem
                            key={item.id}
                            {...item}
                            onClick={(item) => handleAction('update', item)}
                            onDelete={(item) => handleAction('delete', item)}
                          /> 
                        </Collapse.Panel>
                      ))}
                    </Collapse>
                  </List>
                ) : (
                  <div className="w-full flex justify-center p-20">
                    <Empty />
                  </div>
                )}
              </Row>
            </>
          ) : (
            <> 
              <Row justify="space-between">
                <Col>
                  
                  <Space size={10} className='sort-options'>
                    <IconFont type='icon-icon-' style={{fontSize:20, marginRight:15, paddingLeft:10, marginTop:'3px'}}/>
                    <Button
                      type="text"
                      onClick={() => {
                        store.deliverySortType =
                          store.deliverySortType === 'desc' ? 'asc' : 'desc'
                      }}
                    >
                      交付数
                      {store.deliverySortType === 'asc' && <CaretUpOutlined />}
                      {store.deliverySortType === 'desc' && (
                        <CaretDownOutlined />
                      )}
                    </Button>
                  </Space>
                </Col>
              </Row>
              <Row>{renderTaskSizeTip()}</Row>
              <Row>
                {Object.entries(participantRecord).length > 0 ? (
                  <List className="w-full">
                    {Object.entries(participantRecord)
                      .sort(handleDeliverySort)
                      .map(
                        ([userId, items]: [
                          string,
                          { style: CSSProperties; data: DeliveryItem }[]
                        ]) =>
                          userRecord[userId] && (
                            <ParticipantItem
                              key={userId}
                              userInfo={userRecord[userId]}
                              items={items}
                              onClick={(item) => handleAction('update', item)}
                            />
                          )
                      )}
                  </List>
                ) : (
                  <div className="w-full flex justify-center p-20">
                    <Empty />
                  </div>
                )}
              </Row>
            </>
          )}
        </Space>
      </Card>
      <DeliveryFormModal onClose={()=>{store.dialogMode = false }} ref={ref} mode={store.mode} />
    </div>
  )
}

export default observer(DeliveryList)
